<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('applicationbuyPagos')">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Generar Pagos
      </h1>
     
    </div>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link  class="btn-indigo" :href="route('applicationbuy.create')">
        <span>Agregar</span>
        <span class="hidden md:inline">Pagos</span>
      </inertia-link>
    </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
             
              <th class="px-6 pt-6 pb-4">Fecha</th>
              <th class="px-6 pt-6 pb-4">Proveedor</th>
              <th class="px-6 pt-6 pb-4">Valor</th>
              <th class="px-6 pt-6 pb-4">Empresa</th>             
            </tr>
            <tr v-for="applicationbuy in applications.data" :key="applicationbuy.id" class="hover:bg-gray-100 focus-within:bg-gray-100  items-center">
            
              <td class="border-t px-6 py-4">
                  {{ applicationbuy.fecha }}
              </td>
              <td class="border-t px-6 py-4">
                  {{ applicationbuy.nombres }}
              </td>
              <td class="border-t px-6 py-4">
                {{  applicationbuy.saldo }}   
              </td>
              <td class="border-t px-6 py-4">
                  {{ applicationbuy.organization.name }}
              </td>
              <td class="border-t px-6 py-4">
              <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('applicationbuy.editPagos', applicationbuy.id)" >Pagar</inertia-link>
              </td>
            </tr>
            <tr v-if="applications.data.length === 0">
              <td class="border-t px-6 py-4" colspan="4">No Encontramos Solicitudes</td>
            </tr>
          </table>
        </div>

    <pagination class="mt-6" :links="applications.links" />
   
  </div>
  
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/LayoutMenu'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'ApplicationsBuy' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    LoadingButton,
  },
  layout: Layout,
  props: {
    filters: Object,
    applications: Object,
    pago: Object,
  },
  data() {
    return {
      popupActive:false,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('applicationbuy.createPagos'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    storePagos() {
      
      this.form2.post('/applicationbuyPagos')
    }
  },
}

</script>
<style lang="scss">
.vs-popup {
    width: 1060px !important;
}
.peque .vs-popup {
    width: 600px !important;
}
.peque1 .vs-popup {
    width: 500px !important;
}
.peque2 .vs-popup {
    width: 500px !important;
}
</style>